import axios from '../utils/axios';
import config from '../utils/config';

const UPDATE_REPORT_DETAILS = config.get('reports_api', 'update_report_details');
const CREATE_REPORT = config.get('reports_api', 'create_report');
const CREATE_CUSTOM_METRIC = config.get('reports_api', 'create_custom');
const POPULAR_METRIC = config.get('reports_api', 'popular_metrics');
const UPDATE_CUSTOM_METRIC = config.get('reports_api', 'update_custom_metric');
const DELETE_CUSTOM_METRIC = config.get('reports_api', 'delete_custom_metric');
const GET_CUSTOM_METRIC = config.get('reports_api', 'get_custom_metric');
const GET_CUSTOM_DICT = config.get('reports_api', 'get_custom_dict');
const GET_CURRENCY = config.get('reports_api', 'get_currency');
const GET_REPORT_DETAILS = config.get('reports_api', 'get_report_details');
const KPI_URL_EFFICIENCY = config.get('dashboard_api', 'get_kpi_metrics');
const BREAKDOWN_ATTRIBUTES_LIST = config.get('reports_api', 'breakdown_attribute_list');
const REMOVE_BREAKDOWN = config.get('reports_api','remove_breakdown');
const FINAL_REPORT = config.get('reports_api', 'final_report');
const GET_ADS = config.get('reports_api', 'get_ads');
const OUTPUT_PREFERENCE = config.get('reports_api', 'output_preferences');
const DELETE_REPORT = config.get('reports_api', 'delete_reports');
const DOWNLOAD_XCEL = config.get('reports_api', 'download_xcel')

async function updateReportDetails(accessToken, username, reportData, reportId, isSaveDraft) {
    try {
      const validateUrl = isSaveDraft ? config.formUrl(UPDATE_REPORT_DETAILS, reportId)+ "?is_validate=false" :
      config.formUrl(UPDATE_REPORT_DETAILS, reportId);
      const updateReportResponse = await axios({
        method: 'put',
        responseType: 'json',
        url: validateUrl,
        data: reportData,
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return updateReportResponse;
    } catch (error) {
      throw error.response;
    }
}

async function getReportDetails(accessToken, username, reportId) {
  try {
    const updateReportResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_REPORT_DETAILS, reportId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

  async function getCurrencyDetails(accessToken, username) {
    try {
      const getCurrencyDetails = await axios({
        method: 'get',
        responseType: 'json',
        url: config.formUrl(GET_CURRENCY),
        headers: {
          'x-access-token': accessToken,
          'x-user': username,
        },
      });
      return getCurrencyDetails;
    } catch (error) {
      throw error.response;
    }
  }

async function createReport(accessToken, username, campaigsData) {
  try {
    const updateReportResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(CREATE_REPORT),
      data: campaigsData,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getReportDetailsByReportID(accessToken, username, reportId) {
  try {
    const updateReportResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(UPDATE_REPORT_DETAILS, reportId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getKpiMetrics(accessToken, username,is_for_reporting=true) {
  try {
    const kpiListResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(KPI_URL_EFFICIENCY) + '?is_for_reporting='+is_for_reporting,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return kpiListResponse;
  } catch (error) {
    throw error.response;
  }
}


async function getBreakdownList(accessToken, username) {
  try {
    const updateReportResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(BREAKDOWN_ATTRIBUTES_LIST),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}

async function deleteBreakdown(accessToken, username, reportId) {
  try {
    const updateReportResponse = await axios({
      method: 'delete',
      responseType: 'json',
      url: config.formUrl(REMOVE_BREAKDOWN, reportId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}



async function createCustomMetric(accessToken, username, customData) {
  try {
    const updateCustomResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(CREATE_CUSTOM_METRIC),
      data: customData,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateCustomResponse;
  } catch (error) {
    throw error.response;
  }
}


async function getCustomDetails(accessToken, username,reportId, advId) {
  try {
    const cusResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_CUSTOM_METRIC,reportId, advId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return cusResponse;
  } catch (error) {
    throw error.response;
  }
} 

async function getCustomDict(accessToken, username, advId) {
  try {
    const cusResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_CUSTOM_DICT,'', advId) + '&only_dict=true',
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return cusResponse;
  } catch (error) {
    throw error.response;
  }
} 

async function updateCustomMetrics(accessToken, username, customData, reportId) {
  try {
    const updateCustomResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(UPDATE_CUSTOM_METRIC, reportId),
      data: customData,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateCustomResponse;
  } catch (error) {
    throw error.response;
  }
}

async function deleteCustomMetric(accessToken, username, reportId) {
  try {
    const updatResponse = await axios({
      method: 'delete',
      responseType: 'json',
      url: config.formUrl(DELETE_CUSTOM_METRIC, reportId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updatResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getPopularMetrics(accessToken, username, advId) {
  try {
    const getpopularMetric = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(POPULAR_METRIC, advId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getpopularMetric;
  } catch (error) {
    throw error.response;
  }
}

async function getFinalReport(accessToken, username,reportID,cycleId) {
  try {
    const getpopularMetric = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(FINAL_REPORT,reportID,cycleId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getpopularMetric;
  } catch (error) {
    throw error.response;
  }
}

async function getTopAds(accessToken, username,reportID,cycleId) {
  try {
    const getpopularMetric = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(GET_ADS,reportID,cycleId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getpopularMetric;
  } catch (error) {
    throw error.response;
  }
}

async function updateReporOutput(accessToken, username, updateData) {
  try {
    const updateResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(OUTPUT_PREFERENCE),
      data: updateData,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });   
    return updateResponse;
  } catch (error) {
    throw error.response;
  }
}

async function deleteReport(accessToken, username, data) {
  try {
    const updateReportResponse = await axios({
      method: 'delete',
      responseType: 'json',
      url: config.formUrl(DELETE_REPORT),
      data: data,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateReportResponse;
  } catch (error) {
    throw error.response;
  }
}


async function downloadXcel(accessToken, username,reportID,cycleId) {
  try {
    const getpopularMetric = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(DOWNLOAD_XCEL) + `?reportId=${reportID}&cycleId=${cycleId}`,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return getpopularMetric;
  } catch (error) {
    throw error.response;
  }
}
export {
    updateReportDetails,
    createReport,
    getCurrencyDetails,
    getReportDetails,
    getReportDetailsByReportID,
    getBreakdownList,
    getKpiMetrics,
    deleteBreakdown,
    createCustomMetric,
    getCustomDetails,
    updateCustomMetrics,
    deleteCustomMetric,
    getPopularMetrics,
    getFinalReport,
    updateReporOutput,
    deleteReport,
    downloadXcel,
    getCustomDict,
    getTopAds
} 